import { Component } from '@angular/core';
import { Router } from '@angular/router';
@Component({
    selector: 'page-ntfound',
    templateUrl: './pagenotfound.component.html'
})
export class PageNotFoundComponent {
    constructor(private router: Router) { }
    goToLogin() {
        localStorage.clear();
        localStorage.removeItem("newlogin");
        localStorage.removeItem("usersession");
        localStorage.removeItem("userVal");
        this.router.navigate(['login']);
    }
}